const SECONDS_PER_MINUTE = 60;

const MINUTES_PER_HOUR = 60;

const LEAST_TIMEAGO_MAX_TIME = 1;

export {
  SECONDS_PER_MINUTE,
  MINUTES_PER_HOUR,
  LEAST_TIMEAGO_MAX_TIME,
};
